export type SkillQuizQuestion = {
  id: string;
  correct: string;
  options: readonly string[];
};

const question = (id: string, correct: string, options: readonly string[]): SkillQuizQuestion => ({
  id,
  correct,
  options,
});

export const startingTeacherQuizzes: Record<string, readonly SkillQuizQuestion[]> = {
  kennisVak: [
    question("methode", "kiezen", ["volgen", "kiezen", "zelf"]),
    question("wereld", "leefwereld", ["toets", "leefwereld", "hoofdstuk"]),
    question("basis", "doorVak", ["doorVak", "alleenTaal", "later"]),
  ],
  kennisCurriculum: [
    question("kerndoelen", "ontwerpen", ["ontwerpen", "archief", "perKind"]),
    question("leerlijnen", "voortbouwen", ["los", "voortbouwen", "uitgever"]),
    question("opMaat", "aanpassen", ["aanpassen", "gelijk", "ib"]),
  ],
  instructie: [
    question("les", "opbouw", ["uitleg", "opbouw", "eind"]),
    question("verwachtingen", "uitdagen", ["uitdagen", "makkelijker", "toets"]),
    question("verschillen", "afstemmen", ["tempo", "afstemmen", "so"]),
  ],
  effect: [
    question("zien", "volgen", ["volgen", "rapport", "methode"]),
    question("bijsturen", "aanpassen", ["aanpassen", "herhalen", "mentor"]),
    question("eigenaarschap", "sturen", ["rapport", "sturen", "geen"]),
  ],
  relatie: [
    question("veilig", "elke", ["elke", "vriendschap", "vast"]),
    question("sociaal", "groep", ["zelf", "groep", "pauze"]),
    question("vastlopen", "herkennen", ["herkennen", "wachten", "huis"]),
  ],
  klassen: [
    question("regie", "afspraken", ["klas", "afspraken", "muur"]),
    question("groep", "meedoen", ["lawaai", "meedoen", "straf"]),
    question("routines", "oefenen", ["spontaan", "oefenen", "stil"]),
  ],
  reflectie: [
    question("aanpak", "verbeteren", ["vasthouden", "verbeteren", "mentor"]),
    question("hulp", "opTijd", ["nooit", "opTijd", "eind"]),
    question("visie", "klas", ["document", "klas", "school"]),
  ],
  organisatie: [
    question("team", "samen", ["alleen", "samen", "directie"]),
    question("positie", "rechten", ["onbekend", "alles", "rechten"]),
  ],
  omgeving: [
    question("ouders", "gesprek", ["app", "gesprek", "ib"]),
    question("zorg", "signaal", ["nooit", "wachten", "signaal"]),
  ],
  beroep: [
    question("waarden", "gebruiken", ["kennen", "gebruiken", "school"]),
    question("netwerk", "volgen", ["alleen", "nieuws", "volgen"]),
  ],
};

export function quizFor(skillId: string): readonly SkillQuizQuestion[] {
  return startingTeacherQuizzes[skillId] ?? [];
}

export function quizScore(
  skillId: string,
  answers: Readonly<Record<string, string>>,
): { correct: number; total: number; percent: number; perfect: boolean } {
  const questions = quizFor(skillId);
  const correct = questions.filter((entry) => answers[entry.id] === entry.correct).length;
  const total = questions.length;
  const percent = total === 0 ? 0 : Math.round((correct / total) * 100);
  return { correct, total, percent, perfect: total > 0 && correct === total };
}
